export default __webpack_public_path__ + "static/media/Earziki_Logo.1cd1f14c.svg";